import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { GetData, apiheader } from '../../utils/fetchData';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import InfiniteScroll from 'react-infinite-scroll-component';
import { VendersContext } from '../../context/Store';

const FeaturesData = () => {
  let { isLang } = useContext(VendersContext);

  const dt = useRef(null);
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [deletefeaturesDialog, setDeletefeaturesDialog] = useState(false);
  const [IdDeletefeatures, setIdDeletefeatures] = useState(null);
  const [Data, setData] = useState([]);
  const [deleteLoadind, setdeleteLoadind] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // Initialize current page number
  const [totalPages, setTotalPages] = useState(1); // Initialize total pages to 1

  // Add new features
  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap  btn_gapAr gap-2">
        <Link to="/features/add">
          <Button label={isLang === "en" ? "New features" : 'إضافة ميزة جديدة'} icon="pi pi-plus" size='small' />
        </Link>
      </div>
    );
  };

  // handel image in tabel
  const imageBodyTemplate = (rowData) => {
    return <img src={rowData.image} alt={rowData.image} className="shadow-2 border-round" style={{ width: '150px' }} />;
  };

  // handel btn action in tabel 
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <Link to={`/features/edit/${rowData.id}`}>
          <Button icon="pi pi-pencil" rounded outlined className="mr-2" />
        </Link>
        <Button icon="pi pi-trash" rounded outlined severity="danger" onClick={() => confirmDeletefeatures(rowData)} />
      </div>
    );
  };
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <h4 className="m-0">{isLang === "en" ? "Search by title or description " : '   البحث حسب العنوان أو الوصف '} </h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder={isLang === "en" ? "Search..." : ' بحـــث... '} />
      </span>
    </div>
  );


  const getAllContactUsfeatures = async (page) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/features/?page=${page}`;
      const data = await GetData(url, apiheader);
      setTotalPages(data?.data?.lastPage || 1);
      return data?.data?.data;
    } catch (error) {
      console.error('Error while fetching contact data:', error);
      return [];
    }
  };

  const fetchMoreData = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1; // Calculate the next page
      getAllContactUsfeatures(nextPage).then((newData) => {
        setData((prevData) => [...prevData, ...newData]);
        setCurrentPage(nextPage); // Update the currentPage state
      });
    }
  };

  useEffect(() => {
    getAllContactUsfeatures(currentPage).then((data) => {
      setData(data);
    });
  }, []);

  const confirmDeletefeatures = async (features) => {
    setDeletefeaturesDialog(true);
    setIdDeletefeatures(features.id)
  };
  const deletefeatures = async () => {
    setdeleteLoadind(true)
    await axios.delete(`${process.env.REACT_APP_API_URL}/features/${IdDeletefeatures}`, apiheader).then(({ data }) => {
      console.log(data);
      if (data?.status) {
        toast.current.show({ severity: 'success', summary: 'Successful', detail: data?.message, life: 3000 });

        setTimeout(() => {
          setDeletefeaturesDialog(false);
          getAllContactUsfeatures(currentPage)
          setdeleteLoadind(false)
        }, 1000);
      }
    }).catch((error) => {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Data invalid', life: 3000 });
      setdeleteLoadind(false)
    })

  };
  const hideDeletefeaturesDialog = () => setDeletefeaturesDialog(false);
  const deletefeaturesDialogFooter = (
    <div className='btn_gapAr'>
      <Button label={isLang == "en" ? 'No' : 'لا'} icon="pi pi-times" outlined onClick={hideDeletefeaturesDialog} />
      <Button label={isLang == "en" ? 'Yes' : 'نــعم'} loading={deleteLoadind} icon="pi pi-check" severity="danger" onClick={deletefeatures} />
    </div>
  );

  return (
    <div>
      <Toast ref={toast} position={isLang === "en" ? 'top-right' : 'top-left'} />
      <div className="card">
        <Toolbar className="mb-4" left={leftToolbarTemplate}  ></Toolbar>
        <InfiniteScroll
          dataLength={Data.length}
          next={fetchMoreData}
          hasMore={currentPage < totalPages}
          loader={<h4>Loading...</h4>}
        >
          <DataTable
            ref={dt}
            value={Data}
            dataKey="id"
            globalFilter={globalFilter}
            header={header}>
            <Column field="title_en" header={isLang === "en" ? "title_en" : 'العنوان بالانجليزي'} style={{ minWidth: '11rem', textAlign: 'center' }}></Column>
            <Column field="title_ar" header={isLang === "en" ? "title_ar" : 'العنوان بالعربي '} style={{ minWidth: '11rem', textAlign: 'center' }}></Column>
            <Column field="description_en" header={isLang === "en" ? "description_en" : '  وصف بالانجليزي'} style={{ minWidth: '8rem', textAlign: 'center' }}></Column>
            <Column field="description_ar" header={isLang === "en" ? "description_ar" : 'وصف بالعربي'} style={{ minWidth: '10rem', textAlign: 'center' }}></Column>
            <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '12rem' }}></Column>
          </DataTable>
        </InfiniteScroll>
      </div>

      <Dialog dir={isLang == "en" ? 'ltr' : 'rtl'} visible={deletefeaturesDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={isLang == "en" ? 'Confirm Delete' : 'تأكيد الحذف'} modal footer={deletefeaturesDialogFooter} onHide={hideDeletefeaturesDialog}  >
        <div className="confirmation-content   flex justify-content-start  gap-3 align-items-center">
          <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
          <span>
            {isLang === "en" ? " Are you sure you want to delete   ?" : ' هل أنت متأكد أنك تريد حذف   ؟   '}
          </span>
        </div>
      </Dialog>
    </div>
  )
}
export default FeaturesData
